import { BillingSection } from '@/components/settings/billing-section.tsx'
import { ChildSubscriptionList } from '@/components/settings/child-subscription-list.tsx'
import { SubscriptionOffer } from '@/components/settings/subscription-offer.tsx'
import { useParentSubscriptionPresenter } from '@/presenters/parent-subscription.presenter.ts'

function Spinner() {
  return (
    <div className="flex items-center justify-center py-12">
      <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-gray-900" />
    </div>
  )
}

export function ParentSubscriptionTab() {
  const presenter = useParentSubscriptionPresenter()

  if (presenter.isLoading && !presenter.children.length) {
    return (
      <div className="flex w-full flex-col gap-8 pb-32 pt-4">
        <Spinner />
      </div>
    )
  }

  return (
    <div className="bg-gray-25 mx-auto flex w-full max-w-6xl flex-col gap-12 pb-32 pt-4">
      {/* 1. Mise en avant de l'abonnement disponible */}
      <section>
        <SubscriptionOffer
          children={presenter.children}
          clientSecret={presenter.clientSecret}
          subscriptionOpen={presenter.subscribeOpen}
          onSubscriptionOpenChange={presenter.setSubscribeOpen}
          onHandleSubscribe={presenter.handleSubscribe}
        />
      </section>

      {/* 2. Liste des participants (enfants) */}
      <section className="px-6 sm:px-12 xl:px-0">
        <ChildSubscriptionList
          children={presenter.children}
          onCancel={presenter.handleCancel}
          onRenew={presenter.handleRenew}
          isActionLoading={presenter.isActionLoading}
          selectedChild={presenter.selectedChild}
          setSelectedChild={presenter.setSelectedChild}
        />
      </section>

      {/* 3. Facturation & paiements */}
      <section className="px-6 sm:px-12 xl:px-0">
        <BillingSection
          invoices={presenter.invoices}
          payments={presenter.payments}
          onDownload={presenter.handleDownloadInvoice}
        />
      </section>
    </div>
  )
}
